import HelpView from '@/help/HelpView.vue'

export const HELP = {
    componentName: 'Help',
    component: HelpView
}